module.exports = __webpack_public_path__ + "img/enterprises3.5044df28.png";